import {Navigate,Outlet} from "react-router-dom";
import {useAuth} from "@/context/AuthContext";
export default function ProtectedRoute(){
 const {user,loading,sessionError,checkSession}=useAuth();
 if(loading)return <div className="min-h-screen grid place-items-center text-muted-foreground" role="status">Verificando sessão…</div>;
 if(sessionError)return <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center"><p role="alert">{sessionError}</p><button type="button" className="m20-btn" onClick={checkSession}>Tentar novamente</button></div>;
 if(!user)return <Navigate to="/admin/login" replace/>;
 return <Outlet/>;
}
